import { render, staticRenderFns } from "./HabisMasaBerlaku.vue?vue&type=template&id=06ab10c4&"
import script from "./HabisMasaBerlaku.vue?vue&type=script&lang=js&"
export * from "./HabisMasaBerlaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports